export class ListInventoryResourceTypesResponse {
    'resourceTypes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceTypes",
            "baseName": "resourceTypes",
            "type": "Array<ResourceType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInventoryResourceTypesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
